import { setup } from 'xstate';

/**
 * Connection Request Sidebar Machine
 *
 * Controls which card the desktop sidebar shows.
 *
 * States:
 *   cta       — default; shows "Take a Tour / Request Info" buttons
 *   submitted — shows the "Thanks! We will follow up" confirmation card
 *
 * The only transition is SUBMITTED, sent by the form machine when it
 * successfully reaches its success state.
 */
export const connectionRequestSidebarMachine = setup({
  types: {
    events: {} as { type: 'SUBMITTED' },
  },
}).createMachine({
  id: 'connectionRequestSidebar',
  initial: 'cta',
  states: {
    cta: {
      on: {
        SUBMITTED: 'submitted',
      },
    },
    submitted: {
      type: 'final',
    },
  },
});
